import gql from 'graphql-tag';

export default gql`
  fragment mailCampaignBlockHeaderFragment on MailCampaignBlockHeader {
    id
    bodyColor
    image
    imageAlt
    imageLink
    imageScale
    imageWidth
    imageHeight
    paddingTop
    paddingBottom
    paddingLeft
    paddingRight
    createdAt
    updatedAt
  }
`;
